import {
  CarrierType,
  CarrierVisitDto,
  CarrierVisitsApi,
  CarrierVisitStatus,
} from '@operations/app/api'
import { CarrierVisitRefreshEventPayload } from '@operations/app/api/signalRDtos/carrierVisitRefreshEventPayload'
import { createApiClient } from '@operations/app/http-client'
import { EventTypes } from '@operations/messages/eventsTypes'
import { IEvent, MessageBus } from '@tom-ui/utils'
import { BaseEntityStore } from './base/BaseEntityStore'

export class CarrierVisitStore extends BaseEntityStore<CarrierVisitDto> {
  loadedVesselId?: number

  constructor(private messageBus: MessageBus) {
    super()
    this.messageBus.subscribeEvent<CarrierVisitRefreshEventPayload>(
      EventTypes.CarrierVisitRefresh,
      this.handleCarrierVisitRefreshEvent,
    )
  }

  async loadOne(id: number, force = false) {
    if (!force && this.items.find(v => v.id === id)) return

    const { data } = await createApiClient(CarrierVisitsApi).getOne(id)

    this.updateStoreItem(data, data.id)
    this.loadedVesselId = id
  }

  async load(params?: CarrierVisitLoadParams) {
    const { carrierType, withFutureEtd, carrierVisitStatuses } = params || {}
    const { data } = await createApiClient(CarrierVisitsApi).get(
      carrierType,
      withFutureEtd,
      carrierVisitStatuses,
    )

    this.updateStoreItems(data)
  }

  private readonly handleCarrierVisitRefreshEvent = async (
    event: IEvent<CarrierVisitRefreshEventPayload>,
  ) => {
    const payload = event.payload

    if (payload?.carrierVisits?.some(cv => cv.carrierVisitId === this.loadedVesselId)) {
      await this.loadOne(this.loadedVesselId!, true)
    }
  }
}

interface CarrierVisitLoadParams {
  carrierType?: CarrierType
  carrierVisitStatuses?: CarrierVisitStatus[]
  withFutureEtd?: boolean
}
